import { React, useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const AgentCommission = () => {
    const apiService = new LeaseApiService();
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false]);
    const [agentList, setAgentList] = useState([]);
    const [FilterTab, setFilterTab] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [posedList, setPostedList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [historypagination, setHistoryPagination] = useState();
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const [financialYear, setFinancialYear] = useState(null);
    const fulname = useSelector(getName);
    const { currencyPrecision } = useCurrency();

    // const payload = rowData.filter(r => r.isSelect);

    const [formData, setFormData] = useState({
        agentPerson: [{ label: 'Select Agent', value: '' }],
        agent: [{ label: 'Select Agent', value: '' }],
        transDate: '',
        selectAll: false,
        forDelete: false,
    })

    useEffect(() => {
        fetchDropdownData()
        const savedFY = JSON.parse(localStorage.getItem("selectedFinancialYear"));
        setFinancialYear(savedFY)
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setFormData((prev) => ({ ...prev, transDate: formattedDate }));
    }, [])

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        setLoading(true)
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("AgentId", formData?.agent?.value?.value || "All");
            params.append("FYear", financialYear?.id || "0");
            params.append("IsDeleted", formData?.forDelete || false);
            params.append("Month", 1);

            const res = await apiService.getApiParamater('GET_COMMISSION', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getHistoryItems = async (newPageNo = historypagination?.currentPage) => {
        setLoading(true)
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("AgentId", formData?.agentPerson?.value?.value || "All");
            const res = await apiService.getApiParamater('GET_HISTORY_COMMISSION', `?${params.toString()}`);
            setPostedList(res?.data?.result || []);
            setHistoryPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'AgentCommissionAgentNames');
            const res = await apiService.getApiParamater('COMMISSION_MULTI', `?${params.toString()}`);
            setAgentList([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.AgentCommissionAgentNames]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    // Calculate Amount based on Percentage

    const calculateAmount = (row) => {
        const saleValue = Number(row.saleValue) || 0;
        const percentage = Number(row.percentage) || 0;

        let amount = (saleValue * percentage) / 100;
        let vatAmount = 0;
        let totalAmount = amount;

        if (row.isVat) {
            vatAmount = (amount * 10) / 100; // 10% VAT
            totalAmount = amount + vatAmount;
        }

        return {
            ...row,
            amount,
            vatAmount,
            totalAmount,
        };
    };

    // Calculate Percentage based on Amount
    const calculatePercentage = (row) => {
        const monthrent = Number(row.saleValue) || 0;
        const percnt = Number(row.percentage) || 0;
        const mntcnt = Number(row.monthCnt) || 0;
        let finalmonth = (monthrent * mntcnt)
        let amount = (finalmonth * percnt) / 100;

        let percentage = finalmonth !== 0 ? (amount * 100) / finalmonth : 0;
        let vatAmount = 0;
        let totalAmount = amount;

        if (row.isVat) {
            vatAmount = (amount * 10) / 100; // 10% VAT
            totalAmount = amount + vatAmount;
        }
        
        return {
            ...row,
            percentage,
            vatAmount,
            totalAmount,
        };
    };

    const calculatemonthcum = (row) => {
        const monthrent = Number(row.saleValue) || 0;
        const percnt = Number(row.percentage) || 0;
        const mntcnt = Number(row.monthCnt) || 0;
        let finalmonth = (monthrent * mntcnt)
        let amount = (finalmonth * percnt) / 100;
        let vatAmount = 0;
        let totalAmount = amount;
        if (row.isVat) {
            vatAmount = (amount * 10) / 100; // 10% VAT
            totalAmount = amount + vatAmount;
        }
        
        return {
            ...row,
            amount,
            vatAmount,
            totalAmount,
        };
    };

    const columnDefs = [
        {
            headerName: '',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            width: 50,
            suppressMovable: true,
        },
        { headerName: 'Resv No', field: 'resvNo', width: 140 },
        { headerName: 'Agent Id', field: 'salespersonId', width: 120 },
        { headerName: 'Name', field: 'salespersonName', width: 150 },

        {
            headerName: 'Monthly Rent',
            field: 'saleValue',
            editable: false,
            width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: 'Comm. Month',
            field: 'monthCnt',
            editable: true,
            width: 100
        },
        {
            headerName: 'Percent',
            field: 'percentage',
            editable: true,
            width: 100,
            valueFormatter: (params) => params?.value?.toFixed(2)
        },
        {
            headerName: 'Amount',
            field: 'amount',
            editable: true, // allow manual override
            width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },

        {
            headerName: 'Vat',
            field: 'isVat',
            width: 60,
            editable: true,
            cellRenderer: 'agCheckboxCellRenderer',
            cellEditor: 'agCheckboxCellEditor'
        },

        {
            headerName: 'VAT Amount', field: 'vatAmount', width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: 'Total', field: 'totalAmount', width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },

        {
            headerName: 'Narration',
            field: 'narration',
            editable: true,
            width: 200
        },
        { headerName: 'Property', field: 'propertyName', width: 140 },
        { headerName: 'Unit No', field: 'unitNo', width: 140 },
    ];

    const DetailColumns = [
        { headerName: 'Agent Id', field: 'salespersonId', filter: true, floatingFilter: true, suppressMovable: true, width: 90 },
        { headerName: 'Name', field: 'salespersonName', filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
        {
            headerName: 'Monthly Rent', field: 'saleValue', filter: true, floatingFilter: true, suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: 'Percent', field: 'percentage', filter: true, floatingFilter: true, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(2)
        },
        { headerName: 'Months', field: 'exp1', filter: true, floatingFilter: true, suppressMovable: true, width: 90 },
        {
            headerName: 'Amount', field: 'amount', filter: true, floatingFilter: true, suppressMovable: true, width: 100,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        { headerName: 'Narration', field: 'narration', filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: 'Voucher No', field: 'voucherNo', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'Posting Id', field: 'postingId', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Approve', field: 'approved', headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 80 },
        { headerName: 'Posting Type', field: 'postingType', filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: 'FYear', field: 'fYear', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
    ]
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleClearFilters = () => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setFormData({
            agent: [{ label: 'Select Agent', value: '' }],
            transDate: formattedDate,
            selectAll: false,
            forDelete: false,
        });
    }
    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows();

        // update isSelect only in memory
        rowData.forEach(row => {
            row.isSelect = selectedRows.some(
                selected => selected.recordID === row.recordID
            );
        });

        setSelectedRow(selectedRows);
    }
    const onGridReady = (params) => {
        params.api.forEachNode(node => {
            if (node.data.isSelect) {
                node.setSelected(true);
            }
        });
    }
    const handleSave = async () => {
        try {
            setLoader(true);
            if (!formData?.agent?.label) {
                toast.warning("Please Select Agent")
                setLoader(false)
                return
            }
            const commissionList = selectedRow?.map((item, index) => {
                return {
                    fromDate: "1900-01-01T12:27:21.501Z",
                    toDate: "1900-01-01T12:27:21.501Z",
                    tranDate: moment(formData?.transDate).format(),
                    resvNo: item?.resvNo,
                    refNo: "0",
                    monthCnt: item?.monthCnt,
                    invoiceNo: "0",
                    invoiceDate: "1900-01-01T12:27:21.501Z",
                    category: item?.category,
                    salespersonId: item?.salespersonId,
                    salespersonName: item?.salespersonName,
                    saleValue: item?.saleValue,
                    percentage: item?.percentage,
                    amount: item?.amount,
                    vatAmount: item?.vatAmount,
                    totalAmount: item?.totAmount,
                    isInclusive: item?.isInclusive === 0 ? false : true,
                    narration: item?.narration,
                    modifiedBy: fulname,
                    voucherNo: item?.voucherNo,
                    postingId: item?.postingId,
                    voucherSerialNo: parseInt(item?.voucherSerialNo),
                    postingType: item?.postingType,
                    tranId: parseInt(item?.tranId),
                    isSelect: true
                };
            });
            const body = {
                commissionList: commissionList,
                transactionDate: moment(formData?.transDate).format(),
                modifiedBy: fulname
            };
            const postRes = await apiService.post('POST_COMMISSION', body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message);
                setLoader(false);
                window.location.reload();

            } else {
                toast.warning(`${postRes?.data?.message}`);
                setLoader(false);
            }
        } catch (error) {
            toast.error(error.response.data.message)
            console.error('Error Save Data', error);
            setLoader(false);
        } finally {
            setLoader(false);
        }
    }
    const onCellValueChanged = (params) => {
        let updatedRow;
        
        // Determine which field changed
        if (params.colDef.field === "percentage") {
            updatedRow = calculateAmount(params.data);
        } else if (
            params.colDef.field === "amount" || params.colDef.field === "isVat"
        ) {
            updatedRow = calculatePercentage(params.data);
        } else if (params.colDef.field === "monthCnt") {
            updatedRow = calculatemonthcum(params.data);
        } else {
            updatedRow = { ...params.data }; // no change
        }

        // Update rowData state (only this row)
        setRowData(prev =>
            prev.map(row =>
                row.resvNo === updatedRow.resvNo ? updatedRow : row
            )
        );

        // Update ag-Grid node explicitly
        params.node.setData(updatedRow);
    };

    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Agent Commission</h6></div>
            <div className='border-box2  p-2' style={{ borderRadius: "8px" }}>
                <div className='col-lg-8 nav nav-pills overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Posted List
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <>
                    <div className="cost-center-section">
                        <div
                            className="d-flex mt-3 cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}
                        >
                            <div className="h6 pt-1">Search Parameters</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                            <div
                                className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
                                    }`}
                            >
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom18" className="form-label">Agent</label>
                                        <Select
                                            className="p-0 w-100"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                                    color: state.isFocused ? "#000 " : "#000",
                                                    ":hover": {
                                                        backgroundColor: "#F5F5F5",
                                                        color: "#000 ",
                                                    },
                                                }),
                                            }}
                                            value={formData?.agent}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'agent', value: selectedOption })}
                                            options={agentList?.map(country => ({ value: country, label: country?.text }))}
                                        />
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="d-flex gap-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="forDelete"
                                                style={{ width: '20px', height: '20px' }}
                                                checked={formData.forDelete}
                                                onChange={(e) => setFormData(prev => ({ ...prev, forDelete: e.target.checked }))}
                                            />
                                            <label className="form-check-label" htmlFor="forDelete">
                                                for Delete
                                            </label>
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom18" style={{ minWidth: "80px" }} className="form-label w-0">Trans Date</label>
                                            <DatePicker
                                                selected={formData.transDate}
                                                onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex gap-1">
                                        {loading === true ?
                                            <div className='mainbtnGry flex-end gap-2 w-50'>
                                                <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                            </div>
                                            :
                                            <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                                <FaFileCircleExclamation color="#fff" className="center mt-1 mx-2" />
                                                <div className="center">Search</div>
                                            </div>
                                        }
                                        {loader === true ?
                                            <div className='mainbtn flex-end gap-2 w-50'>
                                                <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                            </div>
                                            :
                                            <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                                                <FaSave color='#fff' className='center mt-2 mx-2' />
                                                <div className='center'>Save</div>
                                            </div>
                                        }
                                        <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50" >
                                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Reset</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='gridshad  mt-3'>
                        <div className="ag-theme-quartz" style={{ height: 650 }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}
                                rowSelection="multiple"
                                suppressRowClickSelection={true}
                                floatingFilter={true}
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                onCellValueChanged={onCellValueChanged}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                    </div>
                </>
            )}
            {gridVisibility[1] && (
                <>
                    <div className="cost-center-section">
                        <div
                            className="d-flex mt-3 cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}
                        >
                            <div className="h6 pt-1">Search Parameters</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                            <div
                                className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
                                    }`}
                            >
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom18" className="form-label">Agent Person</label>
                                        <Select
                                            className="p-0 w-100"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                                    color: state.isFocused ? "#000 " : "#000",
                                                    ":hover": {
                                                        backgroundColor: "#F5F5F5",
                                                        color: "#000 ",
                                                    },
                                                }),
                                            }}
                                            value={formData?.agentPerson}
                                            onChange={(selectedOption) => handleDropDownChange({ name: 'agentPerson', value: selectedOption })}
                                            options={agentList?.map(country => ({ value: country, label: country?.text }))}
                                        />
                                    </div>
                                    <div className="d-flex gap-1">
                                        {loading === true ?
                                            <div className='mainbtnGry flex-end gap-2 w-50'>
                                                <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                            </div>
                                            :
                                            <div onClick={() => getHistoryItems()} className="mainbtnGry flex-end gap-2 w-50"                                        >
                                                <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                                <div className="center">Search</div>
                                            </div>
                                        }
                                        <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50"                                        >
                                            <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                            <div className="center">Reset</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='gridshad  mt-3'>
                        <div className="ag-theme-quartz" style={{ height: 650 }}>
                            <AgGridReact
                                getRowStyle={(params) => {
                                    if (params.node.rowIndex % 2 === 0) {
                                        return { background: '#F0EDF5' };
                                    } else {
                                        return { background: '#fff' };
                                    }
                                }}
                                rowData={posedList}
                                enableFilter={true}
                                floatingFilter={true}
                                columnDefs={DetailColumns}
                                onSelectionChanged={onSelectionChanged}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={historypagination} getItems={getHistoryItems} />
                    </div>
                </>
            )}
        </div >
    );
};

export default AgentCommission;